import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  listMerchantQualifications, 
  getMerchantQualificationById,
  updateMerchantQualification
} from '../../api/merchantQualification';
import { message } from 'antd';

// 分页查询商家资质列表的异步 thunk
export const fetchMerchantQualifications = createAsyncThunk(
  'merchantQualification/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await listMerchantQualifications(params);
      return response.data;
    } catch (error) {
      message.error('获取商家资质列表失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 获取商家资质详情的异步 thunk
export const fetchMerchantQualificationDetail = createAsyncThunk(
  'merchantQualification/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getMerchantQualificationById(id);
      return response.data;
    } catch (error) {
      message.error('获取商家资质详情失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 切换商家状态的异步 thunk
export const changeMerchantStatus = createAsyncThunk(
  'merchantQualification/changeStatus',
  async ({ id, status }, { dispatch, rejectWithValue }) => {
    try {
      const response = await updateMerchantQualification({
        id,
        status
      });
      
      if (response.code === 200) {
        message.success(`商家已${status === 'NORMAL' ? '解冻' : '冻结'}`);
        // 重新获取列表
        dispatch(fetchMerchantQualifications());
        return response.data;
      } else {
        message.error(response.message || '状态切换失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('状态切换请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

const merchantQualificationSlice = createSlice({
  name: 'merchantQualification',
  initialState: {
    qualifications: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentQualification: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentQualification: (state, action) => {
      state.currentQualification = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取列表
      .addCase(fetchMerchantQualifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantQualifications.fulfilled, (state, action) => {
        state.loading = false;
        state.qualifications = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchMerchantQualifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 获取详情
      .addCase(fetchMerchantQualificationDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantQualificationDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentQualification = action.payload;
      })
      .addCase(fetchMerchantQualificationDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 切换状态
      .addCase(changeMerchantStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeMerchantStatus.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changeMerchantStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  setPage, 
  setPageSize, 
  setCurrentQualification 
} = merchantQualificationSlice.actions;

export default merchantQualificationSlice.reducer;
